import { createAuthFetch } from "../Authentification/apiFetch";
import { PostPlan, PostPlanStatus } from "./PostPlanTypes";

const API_BASE = process.env.REACT_APP_API_BASE_URL ?? "";

async function parseOrThrow(res: Response) {
    if (!res.ok) {
        const data = await res.json().catch(() => ({}));
        throw new Error(data.error ?? `Serverfehler (${res.status})`);
    }
    return res.json();
}

export function createPostPlanApi(token: string | null) {
    const apiFetch = createAuthFetch(token);

    return {
        async create(payload: { usecases: string[]; entries: PostPlan["entries"] }): Promise<PostPlan> {
            const res = await apiFetch(`${API_BASE}/api/postplans`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(payload),
            });
            return parseOrThrow(res);
        },
        async update(id: string, payload: { usecases: string[]; entries: PostPlan["entries"] }): Promise<PostPlan> {
            const res = await apiFetch(`${API_BASE}/api/postplans/${id}`, {
                method: "PATCH",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(payload),
            });
            return parseOrThrow(res);
        },
        async submitForReview(id: string): Promise<PostPlan> {
            const res = await apiFetch(`${API_BASE}/api/postplans/${id}/submit`, { method: "POST" });
            return parseOrThrow(res);
        },
        async confirm(id: string): Promise<PostPlan> {
            const res = await apiFetch(`${API_BASE}/api/postplans/${id}/confirm`, { method: "POST" });
            return parseOrThrow(res);
        },
        async markPosted(id: string): Promise<PostPlan> {
            const res = await apiFetch(`${API_BASE}/api/postplans/${id}/posted`, { method: "POST" });
            return parseOrThrow(res);
        },
        async unpost(id: string): Promise<PostPlan> {
            const res = await apiFetch(
                `${API_BASE}/api/postplans/${id}/unpost`,
                { method: "POST" }
            );
            return parseOrThrow(res);
        },
        async remove(id: string): Promise<void> {
            const res = await apiFetch(`${API_BASE}/api/postplans/${id}`, { method: "DELETE" });
            if (!res.ok) {
                const data = await res.json().catch(() => ({}));
                throw new Error(data.error ?? `Serverfehler (${res.status})`);
            }
        },
        async list(params: { status?: PostPlanStatus; mine?: boolean } = {}): Promise<PostPlan[]> {
            const query = new URLSearchParams();
            if (params.status) query.set("status", params.status);
            if (params.mine) query.set("mine", "true");
            const res = await apiFetch(`${API_BASE}/api/postplans?${query.toString()}`);
            return parseOrThrow(res);
        },
        async get(id: string): Promise<PostPlan> {
            const res = await apiFetch(`${API_BASE}/api/postplans/${id}`);
            return parseOrThrow(res);
        },
    };
}